import { pRecordVideoSquare } from "../../utils/parameters"

/* Save video locally */
export async function saveVideo(mediaBlobUrl) {
    console.log("🚀 ~ saveVideo ~ mediaBlobUrl:", mediaBlobUrl)
    const response = await fetch(mediaBlobUrl);
    const videoBlob = await response.blob();
    const videoFile = new File([videoBlob], "teo.mp4", { type: "video/mp4" })
    console.log("🚀 ~ saveVideo ~ videoFile size:", videoFile.size) // Log the size of the file

    return videoFile;
}

/* Download video in the computer */
export function downloadVideo(file) {
    var link = document.createElement("a");
    link.download = file.name;
    link.href = file;
    link.click();
}

/* Check Webcam permissions */
export let webcamModel = "";
export async function checkCameraPermissions() {
    var aux = false;
    await navigator.mediaDevices.getUserMedia({ audio: pRecordVideoSquare.audio, video: pRecordVideoSquare.video });
    await (navigator.mediaDevices.enumerateDevices()).then(
        media => {
            for (const i of media) {
                if (i.kind.toLowerCase().includes('videoinput')) {
                    if (i.label.length !== 0) {
                        console.log("Webcam model: " + i.label)
                        webcamModel = i.label;
                        aux = true;
                    }
                }
            }
        });
    return aux;
}

/* Stop camera */
export function stopWebcam() {
    navigator.mediaDevices.getUserMedia({ audio: pRecordVideoSquare.audio, video: pRecordVideoSquare.video })
        .then(stream => stream.getVideoTracks().forEach(function (track) {
            if (track.readyState === 'live' && track.kind === 'video') {
                track.enabled = false;
            }
        }))
}

/* Get webcam info */
export async function getWebcamModel() {
    let webcam = ""
    await (navigator.mediaDevices.enumerateDevices()).then(
        media => {
            for (const i of media) {
                if (i.kind.toLowerCase().includes('videoinput')) {
                    if (i.label.length !== 0) {
                        webcam = i.label;
                        break;
                    }
                }
            }
        });
    return webcam;
}